import AsideNavLink from '../../components/aside-nav-link';
import AsideLayout from '../../components/layouts/aside-layout';
import ContactUsForm from '../../components/contact-us-form';
import MainLayout from '../../components/layouts/main-layout';
import HeroImage from '../../public/img/hero/contact_us_1920_640.jpg';
import Link from 'next/link';
import Head from 'next/head';

export default function ContactUs() {
    return (
        <MainLayout>
            <Head>
                <title>Contact Us | Solvar</title>
                <meta name="description" content="Solvar contact us."></meta>
            </Head>
            <AsideLayout
                heroImage={ HeroImage }
                location={
                    <p className="capitalize text-bb">
                        <span className="font-bold">Contact</span> › Contact Us
                    </p>
                }
                aside={
                    <>
                        <h6 className="text-h3 text-bb pb-20">About Us</h6>
                        <AsideNavLink href="/about-us/company-overview">Company Overview</AsideNavLink>
                        <AsideNavLink href="/about-us/history">History</AsideNavLink>
                        <AsideNavLink href="/about-us/board-of-directors">Board of Directors</AsideNavLink>
                        <AsideNavLink href="/about-us/management-team">Management Team</AsideNavLink>
                        <AsideNavLink href="/about-us/corporate-governance">Corporate Governance</AsideNavLink>
                        <AsideNavLink href="/about-us/philanthropy">Philanthropy</AsideNavLink>
                        <AsideNavLink href="/about-us/sustainability">Sustainability</AsideNavLink>
                        <h6 className="text-h3 text-bb pb-20 pt-40">Investors</h6>
                        <AsideNavLink href="/investors/shareholder-information">Shareholder Information</AsideNavLink>
                        <AsideNavLink href="/investors/company-announcements">Company Announcements</AsideNavLink>
                        <AsideNavLink href="/investors/annual-reports">Annual Reports</AsideNavLink>
                        <h6 className="text-h3 text-bb pb-20 pt-40">Contact</h6>
                        <AsideNavLink href="/contact/contact-us" active={true}>Contact Us</AsideNavLink>
                    </>
                }
            >
                <h1 className="text-bb pb-40">Contact Us</h1>
                <div className="sol-markdown-content">
                    <p>
                        <strong>Solvar Limited</strong><br />
                        Level 1/40 Graduate Rd,<br />
                        Bundoora VIC 3083<br />
                        Tel: <Link href="tel:0390938255">03 9093 8255</Link>
                    </p>
                    <hr />
                    <p>Alternatively, you can contact us via the form below and we'll be in touch with you as soon as possible.</p>
                </div>
                <ContactUsForm />
            </AsideLayout>
        </MainLayout>
    );
}
